import memoize from 'memoizerific'
import emptyReservation from '../reservations/emptyReservation'

export const getItemKey = item => (
  (item.type == "other_expense" && item._id) 
  || item.agendaItem.ref 
  || item.agendaItem.key
)

const _createReservationFromItem = (tripId, item, initials) => {
  const agendaItem = item.referencedAgendaItem || item.agendaItem
  return {
    ...emptyReservation, 
    
    tripId, 
    itemKey: getItemKey(item), 
    name: item.name, 
    title: item.title, 
    time: item.time, 
    date: item.date,
    type: item.type, 
    priceValue: item.priceValue, 
    
    ...(
      (item.type == "city" && {
        origin: item.origin, 
        destination: item.destination, 
      }) 
      || (item.type == "activity" && {
        activityId: item.activityId,
        city: item.city,
      })
      || ((item.type == "expense" || item.type == "hotel") && {
        expenseTitle: agendaItem.expense.title, 
        expenseName: agendaItem.expense.name, 
        expenseType: agendaItem.expense.type, 
        repetitionDates: item.repetitionDates, 
        numRepetitions: item.numRepetitions, 
        city: item.city,
      })
    ), 

    ...(initials || {})
  }
}

/* #TODO Sustituir el 200 por la ruta que mas elementos tiene */

export const createReservationFromItem = memoize(200)(_createReservationFromItem)